"use client"

import {
  ProfilePicture,
  Tooltip,
  useUploadImageModal,
} from "@store-platform/ui/common"
import { SvgCamera } from "@store-platform/ui/icons"
import { cn } from "@store-platform/utils"
import { clearUserCache } from "../actions"
import { toast } from "sonner"
import { BackendApi, backendApi } from "@store-platform/backend/common"
import { endpointUpdateProfilePicture } from "@store-platform/backend/endpoints"
import { useBackendApi } from "@store-platform/backend/api-client"

async function uploadProfilePicture(
  api: BackendApi,
  username: string,
  image: File,
) {
  const { error } = await backendApi(
    api,
    endpointUpdateProfilePicture({ profilePicture: image }),
  )
  if (error) {
    toast.error("Failed to update profile picture")
    return
  }

  toast.success("Profile picture updated successfully")
  await clearUserCache(username)
}

export interface EditableProfilePictureProps {
  username: string
  pictureUrl?: string
  pictureFallback: string
  allowEdit?: boolean
  className?: string
}

export function EditableProfilePicture(props: EditableProfilePictureProps) {
  const backendApi = useBackendApi()
  const modal = useUploadImageModal()

  return (
    <>
      <div className={cn("relative", props.className)}>
        <ProfilePicture
          size="l"
          imgUrl={props.pictureUrl}
          fallback={props.pictureFallback}
          priority={true}
          className="bg-white ring-4 ring-white"
        />
        {!!props.allowEdit && (
          <>
            <Tooltip caption="Change Profile Picture" side="right">
              <button
                className="w-8 h-8 rounded-full absolute bottom-1 -right-1 bg-blue-500 border-2 border-neutral-100 flex items-center justify-center"
                onClick={() =>
                  modal.open({
                    title: "Change Profile Picture",
                    shape: "round",
                    aspectRatio: 1,
                    outputFormat: "file",
                    action: async (image) => {
                      await uploadProfilePicture(
                        backendApi,
                        props.username,
                        image,
                      )
                    },
                  })
                }
              >
                <SvgCamera className="text-white" />
              </button>
            </Tooltip>
          </>
        )}
      </div>
    </>
  )
}
